
import { useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [showBookingModal, setShowBookingModal] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Hero onBookNow={() => setShowBookingModal(true)} />
      <Services />
      <About />
      <Gallery />
      <Contact showModal={showBookingModal} onClose={() => setShowBookingModal(false)} />
      <Footer />
    </div>
  );
}
